// Project/highways/UpdateHighwayProject.jsx

import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { AUTH, BASE_URL } from "../../../config/axios";
import { UpdatePencil } from "../../AllSvg";
import { Modal } from "react-bootstrap";
import { CSSForSelect, CSSForSelect15VW } from "../../CustomFunctions";
import { AddWithPlus } from "../../Buttons";
import Select, { components } from "react-select";


const HIGHWAY_SECTOR_UUID = "9d74ca44-5bff-4ecb-afac-aba5663eb2d0";

// ── Option & MenuList ──────────────────────────────────────────────────────
const Option = (props) => (
  <components.Option {...props}>
    <label title="Star" className="star">
      <input
        id="star-checkbox"
        checked={props.isSelected}
        onChange={() => null}
        className="checkbox"
        type="checkbox"
      />
      <div className="svg-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-outline"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z" />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-filled"
          viewBox="0 0 24 24"
        >
          <path d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z" />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="100"
          width="100"
          className="svg-celebrate"
        >
          {[...Array(8)].map((_, idx) => (
            <circle key={idx} r="2" cy="50" cx="50" className="particle" />
          ))}
        </svg>
      </div>
    </label>
    {props.label}
  </components.Option>
);

const MenuList = (props) => {
  const { options, selectProps } = props;
  const filteredOptions = options.filter(
    (opt) => opt.label.toLowerCase() !== "other",
  );
  const selectedValues = selectProps.value?.map((i) => i.value) || [];
  const filteredValues = filteredOptions.map((i) => i.value);
  const isAllSelected = filteredValues.every((val) =>
    selectedValues.includes(val),
  );
  const handleToggle = () => {
    const preserveOther =
      selectProps.value?.filter((i) => i.label.toLowerCase() === "other") || [];
    selectProps.onChange(
      isAllSelected ? preserveOther : [...filteredOptions, ...preserveOther],
    );
  };
  return (
    <components.MenuList {...props}>
      <button
        onClick={handleToggle}
        style={{
          width: "100%",
          padding: "6px 0",
          cursor: "pointer",
          fontWeight: "600",
          borderBottom: "1px solid #e3e3e3",
          background: "white",
        }}
      >
        {isAllSelected ? "Unselect All" : "Select All"}
      </button>
      {props.children}
    </components.MenuList>
  );
};

// ── Static Data ────────────────────────────────────────────────────────────
const departListHighway = [
  { value: "NHAI", label: "NHAI" },
  { value: "MoRTH", label: "MoRTH" },
  { value: "NHIDCL", label: "NHIDCL" },
  { value: "BRO", label: "BRO" },
  { value: "PWDs", label: "PWDs" },
  { value: "MPRDCL", label: "MPRDCL" },
  { value: "BHDCL", label: "BHDCL" },
  { value: "HSIIDC", label: "HSIIDC" },
  { value: "SHAJ", label: "SHAJ" },
  { value: "GJRDCL", label: "GJRDCL" },
  { value: "MHRDCL", label: "MHRDCL" },
  { value: "UPEIDA", label: "UPEIDA" },
  { value: "UPHA&SP", label: "UPHA&SP" },
  { value: "RITES", label: "RITES" },
  { value: "APCRDA", label: "APCRDA" },
  { value: "RCDB", label: "RCDB" },
  { value: "BSIL", label: "BSIL" },
  { value: "BUIDCL", label: "BUIDCL" },
  { value: "CMRL", label: "CMRL" },
  { value: "DMRCL", label: "DMRCL" },
  { value: "EPIL", label: "EPIL" },
  { value: "HRSI&IDCL", label: "HRSI&IDCL" },
  { value: "H&UDCL", label: "H&UDCL" },
  { value: "J&KRRDA", label: "J&KRRDA" },
  { value: "MHSIDC", label: "MHSIDC" },
  { value: "MHMRCL", label: "MHMRCL" },
  { value: "RJSRD&CCL", label: "RJSRD&CCL" },
  { value: "KARDCL", label: "KARDCL" },
  { value: "TNRDL", label: "TNRDL" },
  { value: "APRDC", label: "APRDC" },
  { value: "PBIDB", label: "PBIDB" },
  { value: "R&BDT", label: "R&BDT" },
  { value: "RCDJ", label: "RCDJ" },
  { value: "JHSRDC", label: "JHSRDC" },
  { value: "HPPWD", label: "HPPWD" },
  { value: "UKPWD", label: "UKPWD" },
  { value: "DSI&IDC", label: "DSI&IDC" },
  { value: "GOAPWD", label: "GOAPWD" },
  { value: "HRRIDC", label: "HRRIDC" },
  { value: "RIDFOD", label: "RIDFOD" },
  { value: "RJSID&IC", label: "RJSID&IC" },
  { value: "KLRFB", label: "KLRFB" },
  { value: "RSHA", label: "RSHA" },
  { value: "BIDA", label: "BIDA" },
  { value: "MIDFC", label: "MIDFC" },
  { value: "JKSCC", label: "JKSCC" },
  { value: "SOI", label: "SOI" },
  { value: "JNPT", label: "JNPT" },
  { value: "BMRCL", label: "BMRCL" },
  { value: "KRCL", label: "KRCL" },
  { value: "OBCCL", label: "OBCCL" },
  { value: "NHSRCL", label: "NHSRCL" },
  { value: "Other", label: "Other" },
];

const costTypeList = [
  { value: "crore", label: "In Crore" },
  { value: "lakh", label: "In Lakh" },
  { value: "thousand", label: "In Thousand" },
  { value: "crore_lakh", label: "In Crore & Lakh" },
  { value: "lakh_thousand", label: "In Lakh & Thousand" },
  { value: "crore_lakh_thousand", label: "In Crore, Lakh & Thousand" },
];

// ── Main Component ─────────────────────────────────────────────────────────
const UpdateHighwayProject = ({ i, getProjectname, getProject }) => {
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [subCompany, setSubCompany] = useState([]);
  const [company, setCompany] = useState([]);
  const [CostType, setCostType] = useState("null");
  const [croreInput, setCroreInput] = useState("");
  const [lakhInput, setLakhInput] = useState("");
  const [thousandInput, setThousandInput] = useState("");
  const isFirstRender = useRef(true);

  const emptyForm = {
    pr_code: "",
    project_name: "",
    division: "null",
    department: "",
    subcompany: "",
    work_type_id: "",
    loa_date: "",
    total_length: "",
    project_post: "",
    basic_value: "",
    gst_amount: "0",
    total_amount: "",
    completion_date: "",
    workstages: [],
    sector: HIGHWAY_SECTOR_UUID,
    project_short_name: "",
  };

  const [formData, setFormData] = useState(emptyForm);

  const handleShow = () => {
    setShow(true);
    // old projects may have basic_value 0/empty -> fall back to project_post
    const basic = Number(i.basic_value) > 0 ? i.basic_value : i.project_post;
    const gst = i.gst_amount ?? 0;
    setFormData({
      ...i,
      basic_value: basic,
      project_post: basic,
      gst_amount: gst,
      total_amount: Number(basic || 0) + Number(gst || 0),
    });
  };
  const handleClose = () => {
    setShow(false);
    setFormData(emptyForm);
    setCostType("null");
    setCroreInput("");
    setLakhInput("");
    setThousandInput("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => {
      const u = { ...prev };
      delete u[name];
      return u;
    });
  };

  // GST box: only touches gst_amount and total_amount
  const handleGstChange = (e) => {
    const v = e.target.value;
    setFormData((p) => ({
      ...p,
      gst_amount: v,
      total_amount: Number(p.project_post || 0) + Number(v || 0),
    }));
  };

  // Plain "Project Cost" box (shown when no Cost Type is picked)
  const handleBasicChange = (e) => {
    const v = e.target.value;
    setFormData((p) => ({
      ...p,
      project_post: v,
      basic_value: v,
      total_amount: Number(v || 0) + Number(p.gst_amount || 0),
    }));
    setErrors((prev) => {
      const u = { ...prev };
      delete u.project_post;
      return u;
    });
  };

  // ── Validation ─────────────────────────────────────────────────────────
  const validateform = () => {
    const newErrors = {};
    const requiredFields = [
      "pr_code",
      "project_name",
      "division",
      "department",
      "subcompany",
      "work_type_id",
      "loa_date",
      "total_length",
      "completion_date",
      "workstages",
      "sector",
      "project_short_name",
      "project_post",
    ];
    requiredFields.forEach((field) => {
      const value = formData[field];
      if (typeof value === "string" && value.trim() === "")
        newErrors[field] = "This field is required!";
      else if (Array.isArray(value) && value.length === 0)
        newErrors[field] = "This field is required!";
      else if (value === null || value === undefined || value === "null")
        newErrors[field] = "This field is required!";

      if (CostType !== "null") {
        if (CostType === "crore_lakh_thousand") {
          if (!croreInput.trim())
            newErrors["croreInput"] = "This field is required!";
          if (!lakhInput.trim())
            newErrors["lakhInput"] = "This field is required!";
          if (!thousandInput.trim())
            newErrors["thousandInput"] = "This field is required!";
        } else if (CostType === "crore_lakh") {
          if (!croreInput.trim())
            newErrors["croreInput"] = "This field is required!";
          if (!lakhInput.trim())
            newErrors["lakhInput"] = "This field is required!";
        } else if (CostType === "lakh_thousand") {
          if (!lakhInput.trim())
            newErrors["lakhInput"] = "This field is required!";
          if (!thousandInput.trim())
            newErrors["thousandInput"] = "This field is required!";
        } else if (CostType === "crore" && !croreInput.trim())
          newErrors["croreInput"] = "This field is required!";
        else if (CostType === "lakh" && !lakhInput.trim())
          newErrors["lakhInput"] = "This field is required!";
        else if (CostType === "thousand" && !thousandInput.trim())
          newErrors["thousandInput"] = "This field is required!";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateform()) return;
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      const oldProjectCost = parseFloat(i.project_post || 0);
      const newProjectCost = parseFloat(formData.project_post || 0);

      const payload = {
        ...formData,
        basic_value: Number(formData.project_post || 0),
        gst_amount: Number(formData.gst_amount || 0),
        total_amount:
          Number(formData.project_post || 0) + Number(formData.gst_amount || 0),
      };
      const res = await axios.put(
        `${BASE_URL}/dpr/projectdetails/${i.id}/`,
        payload,
        AUTH(),
      );

      if (res.status === 201 || res.status === 200) {

        // ✅ CASCADE: if project cost changed, update all sections + workstages
        if (newProjectCost !== oldProjectCost && oldProjectCost > 0) {
          try {
            const sectionsRes = await axios.get(
              `${BASE_URL}/dpr/project/`,
              AUTH()
            );

            // filter only sections belonging to this project
            const sections = sectionsRes.data.filter(
              (s) => s.project_details === i.id
            );

            for (const section of sections) {
              const oldSectionCost = parseFloat(section.section_cost || 0);

              // proportional recalculation
              const ratio = oldSectionCost / oldProjectCost;
              const newSectionCost = (ratio * newProjectCost).toFixed(2);

              // recalculate each workstage cost from its percentage
              const updatedWorkstat = (section.workstat || []).map((ws) => ({
                ...ws,
                cost: (
                  (parseFloat(ws.percentage || 0) / 100) *
                  parseFloat(newSectionCost)
                ).toFixed(2),
              }));

              await axios.put(
                `${BASE_URL}/dpr/project/${section.id}/`,
                {
                  ...section,
                  section_cost: newSectionCost,
                  workstat: updatedWorkstat,
                },
                AUTH()
              );
            }
          } catch (cascadeErr) {
            console.error("Section cascade update failed:", cascadeErr);
            toast.warn("Project updated but section costs may need manual refresh.");
          }
        }

        toast.success("Highway Project updated successfully!");
        handleClose();
        await getProjectname();
        if (getProject) await getProject(); 
      }
    } catch (err) {
      toast.error(
        err.response?.data
          ? `Failed: ${JSON.stringify(err.response.data)}`
          : "Failed to update project",
      );
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // ── Company / SubCompany ───────────────────────────────────────────────
  const fetchCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/subcompany/`);
      setCompany(res.data);
    } catch (err) {
      toast.error("Failed to fetch company data.");
    }
  };
  const fetchSubcompany = async () => {
    if (!formData.subcompany || formData.subcompany === "null") return;
    try {
      const res = await axios.get(
        `${BASE_URL}/dpr/divisionfilterbysubcompany/${formData.subcompany}/`,
      );
      setSubCompany(res.data);
    } catch (err) {
      toast.error("Failed to fetch sub company data.");
    }
  };
  useEffect(() => {
    if (show) fetchCompany();
  }, [show]);
  useEffect(() => {
    fetchSubcompany();
  }, [formData.subcompany]);

  useEffect(() => {
    if (formData.subcompany === "null") {
      setFormData((prev) => ({ ...prev, division: "null" }));
      setSubCompany([]);
    }
  }, [formData.subcompany]);

  const companyOptions = company
    ?.sort((a, b) =>
      a.company_name?.localeCompare(b.company_name, "en", {
        ignorePunctuation: true,
      }),
    )
    .map((i) => ({ value: i.id, label: i.company_name }));
  const subCompanyOptions = subCompany
    ?.sort((a, b) =>
      a.division_name?.localeCompare(b.division_name, "en", {
        ignorePunctuation: true,
      }),
    )
    .map((i) => ({ value: i.id, label: i.division_name }));

  const handleCompanyInputOptions = (sel) => {
    setFormData((prev) => ({ ...prev, subcompany: sel ? sel.value : "null" }));
  };
  const handleSubCompanyInputOptions = (sel) => {
    setFormData((prev) => ({ ...prev, division: sel ? sel.value : "null" }));
  };

  // ── Department ─────────────────────────────────────────────────────────
  const departmentHighwayOption = departListHighway
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((i) => ({ value: i.value, label: i.label }));

  const handleDepartmentChange = (sel) => {
    setFormData((prev) => ({ ...prev, department: sel ? sel.value : "" }));
    setErrors((prev) => {
      const u = { ...prev };
      delete u.department;
      return u;
    });
  };

  // ── Work Type ──────────────────────────────────────────────────────────
  const [workTypeList, setWorktypeList] = useState([]);
  const [formData2, setFormData2] = useState({ name: "", division: "" });
  const [error2, setErrors2] = useState({});
  const [removeWorkTypeInputField, setRemoveWorkTypeInputField] =
    useState(false);

  const getData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/worktype/`);
      setWorktypeList(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (show) getData();
  }, [show]);

  const workTypeOption = workTypeList
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({ value: i.id, label: i.name }));
  const extendedworkTypeOption = [
    ...workTypeOption,
    { label: "Other", value: "other" },
  ];

  const handleWorkTypeOption = (sel) => {
    setFormData((prev) => ({
      ...prev,
      work_type_id: sel ? sel.value : "null",
    }));
  };
  useEffect(() => {
    if (removeWorkTypeInputField)
      setFormData((prev) => ({ ...prev, work_type_id: "null" }));
  }, [removeWorkTypeInputField]);
  useEffect(() => {
    if (formData.work_type_id === "other") setRemoveWorkTypeInputField(false);
  }, [formData.work_type_id]);

  const validateform2 = () => {
    const newErrors = {};
    if (!formData2.name?.trim()) newErrors.name = "This field is required!";
    setErrors2(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleFormSubmit2 = async (e) => {
    e.preventDefault();
    if (!validateform2()) return;
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      const res = await axios.post(
        `${BASE_URL}/dpr/worktype/`,
        { ...formData2, division: formData.division },
        AUTH(),
      );
      if (res.status === 201 || res.status === 200) {
        toast.success("Worktype added successfully!");
        setFormData2({ name: "", division: "" });
        getData();
        setFormData((prev) => ({ ...prev, work_type_id: res.data.id }));
      }
    } catch (err) {
      toast.error("Failed to add Worktype");
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // ── Workstages ─────────────────────────────────────────────────────────
  const [workStagesList, setworkStagesList] = useState([]);
  const [formData4, setFormData4] = useState({
    name: "",
    percentage: "",
    workstage_inputtype: "",
    stage: [],
    normal_input: [],
    submission_data: [],
  });
  const [error4, setErrors4] = useState({});
  const [inputValue, setinputValue] = useState("");

  const getData3 = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/workstats/`);
      setworkStagesList(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (show && formData.division !== "null") getData3();
  }, [show, formData.division]);

  const WorkStatOption = workStagesList
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({ value: i.id, label: i.name }));
  const extendedWorkStatOption = [
    ...WorkStatOption,
    { label: "Other", value: "other" },
  ];

  const inputOptions = [
    { value: "Submission", label: "Submission" },
    { value: "Stage", label: "Stage" },
    { value: "Input", label: "Input" },
  ].sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    setFormData4((prev) => ({ ...prev, workstage_inputtype: inputValue }));
  }, [inputValue]);

  const validateform4 = () => {
    const newErrors = {};
    if (!formData4.name?.trim()) newErrors.name = "This field is required!";
    if (!formData4.workstage_inputtype?.trim())
      newErrors.workstage_inputtype = "This field is required!";
    setErrors4(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleFormSubmit4 = async (e) => {
    e.preventDefault();
    if (!validateform4()) return;
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      const res = await axios.post(
        `${BASE_URL}/dpr/workstats/`,
        formData4,
        AUTH(),
      );
      if (res.status === 201 || res.status === 200) {
        toast.success("Workstage added successfully!");
        setFormData4({ name: "", division: "" });
        getData3();
        const cleanedWorkstages = formData.workstages.filter(
          (w) => w !== "other",
        );
        setFormData((prev) => ({
          ...prev,
          workstages: [...cleanedWorkstages, res.data.id],
        }));
      }
    } catch (err) {
      toast.error("Failed to add Workstage");
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // ── Sector (read-only) ─────────────────────────────────────────────────
  const [sectorList, setSectorList] = useState([]);
  const getData2 = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/dpr/subconsultant/`);
      setSectorList(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (show) getData2();
  }, [show]);
  const sectorOption = sectorList
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((i) => ({ value: i.id, label: i.name }));
  const extendedSectorOption = [
    ...sectorOption,
    { label: "Other", value: "other" },
  ];

  // ── Cost Type ──────────────────────────────────────────────────────────
  const costTypesOptions = costTypeList
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((i) => ({ value: i.value, label: i.label }));

  const handleCostTypeChange = (sel) => {
    setCostType(sel ? sel.value : "null");
  };
  const handleCroreInputChange = (e) => {
    if (/^\d{0,3}$/.test(e.target.value)) setCroreInput(e.target.value);
  };
  const handleLakhInputChange = (e) => {
    if (/^\d{0,2}$/.test(e.target.value)) setLakhInput(e.target.value);
  };
  const handleThousandInputChange = (e) => {
    if (/^\d{0,5}$/.test(e.target.value)) setThousandInput(e.target.value);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setCroreInput("");
    setLakhInput("");
    setThousandInput("");
    setFormData((prev) => ({
      ...prev,
      project_post: "",
      basic_value: "",
      total_amount: Number(prev.gst_amount || 0),
    }));
  }, [CostType]);

  useEffect(() => {
    const buildCost = () => {
      if (
        CostType === "crore_lakh_thousand" &&
        croreInput &&
        lakhInput &&
        thousandInput
      )
        return croreInput + lakhInput + thousandInput;
      if (CostType === "crore_lakh" && croreInput && lakhInput)
        return croreInput + lakhInput;
      if (CostType === "lakh_thousand" && lakhInput && thousandInput)
        return lakhInput + thousandInput;
      if (CostType === "crore" && croreInput) return croreInput;
      if (CostType === "lakh" && lakhInput) return lakhInput;
      if (CostType === "thousand" && thousandInput) return thousandInput;
      return null;
    };
    const val = buildCost();
    if (val)
      setFormData((prev) => ({
        ...prev,
        project_post: val,
        basic_value: val,
        total_amount: Number(val || 0) + Number(prev.gst_amount || 0),
      }));
  }, [CostType, croreInput, lakhInput, thousandInput]);

  // ── Render Cost Section ────────────────────────────────────────────────
  // In Update: when CostType is "null", show existing project_post as editable field
  const renderCostSection = () => {
    const costTypeSelector = (selectorStyle = CSSForSelect15VW) => (
      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading">
          Cost Type
        </label>
        <Select
          options={costTypesOptions}
          onChange={handleCostTypeChange}
          value={costTypesOptions.find((o) => o.value === CostType) || null}
          placeholder="Select Cost Type (optional)"
          isSearchable
          isClearable
          styles={selectorStyle}
        />
      </div>
    );
    const croreField = () => (
      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading">
          Project Cost<span className="required">(in Cr)*</span>
        </label>
        <input
          type="number"
          placeholder="In Crores"
          style={{ width: "15vw" }}
          onChange={handleCroreInputChange}
          value={croreInput}
          className={`form-input ${errors.croreInput ? "input-error" : ""}`}
        />
        {errors.croreInput && (
          <span className="error-message font-size-text">
            {errors.croreInput}
          </span>
        )}
      </div>
    );
    const lakhField = () => (
      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading">
          Project Cost<span className="required">(in Lakh)*</span>
        </label>
        <input
          type="number"
          placeholder="In Lakhs"
          style={{ width: "15vw" }}
          onChange={handleLakhInputChange}
          value={lakhInput}
          className={`form-input ${errors.lakhInput ? "input-error" : ""}`}
        />
        {errors.lakhInput && (
          <span className="error-message font-size-text">
            {errors.lakhInput}
          </span>
        )}
      </div>
    );
    const thousandField = () => (
      <div className="flex-column">
        <label className="form-labels font-weight500 font-size-subheading">
          Project Cost<span className="required">(in Thousands)*</span>
        </label>
        <input
          type="number"
          placeholder="In Thousands"
          style={{ width: "15vw" }}
          onChange={handleThousandInputChange}
          value={thousandInput}
          className={`form-input ${errors.thousandInput ? "input-error" : ""}`}
        />
        {errors.thousandInput && (
          <span className="error-message font-size-text">
            {errors.thousandInput}
          </span>
        )}
      </div>
    );

    if (CostType === "null")
      return (
        <div className="flex-row justify-between" style={{ width: "34vw" }}>
          <div className="flex-column">
            <label
              htmlFor="project_post"
              className="form-labels font-weight500 font-size-subheading"
            >
              Project Cost
            </label>
            <input
              type="number"
              id="project_post"
              name="project_post"
              placeholder="Project Cost"
              style={{ width: "15vw" }}
              onChange={handleBasicChange}
              value={formData.project_post}
              className={`form-input ${errors.project_post ? "input-error" : ""}`}
            />
            {errors.project_post && (
              <span className="error-message font-size-text">
                {errors.project_post}
              </span>
            )}
          </div>
          {costTypeSelector()}
        </div>
      );
    if (CostType === "crore")
      return (
        <div className="flex-row justify-between" style={{ width: "35vw" }}>
          {costTypeSelector()}
          {croreField()}
        </div>
      );
    if (CostType === "lakh")
      return (
        <div className="flex-row justify-between" style={{ width: "35vw" }}>
          {costTypeSelector()}
          {lakhField()}
        </div>
      );
    if (CostType === "thousand")
      return (
        <div className="flex-row justify-between" style={{ width: "35vw" }}>
          {costTypeSelector()}
          {thousandField()}
        </div>
      );
    if (CostType === "crore_lakh")
      return (
        <>
          <div className="flex-row justify-between" style={{ width: "35vw" }}>
            {costTypeSelector(CSSForSelect)}
          </div>
          <div className="flex-row justify-between" style={{ width: "35vw" }}>
            {croreField()}
            {lakhField()}
          </div>
        </>
      );
    if (CostType === "lakh_thousand")
      return (
        <>
          <div className="flex-row justify-between" style={{ width: "35vw" }}>
            {costTypeSelector(CSSForSelect)}
          </div>
          <div className="flex-row justify-between" style={{ width: "35vw" }}>
            {lakhField()}
            {thousandField()}
          </div>
        </>
      );
    if (CostType === "crore_lakh_thousand")
      return (
        <>
          <div className="flex-row justify-between" style={{ width: "35vw" }}>
            {costTypeSelector()}
            {croreField()}
          </div>
          <div className="flex-row justify-between" style={{ width: "35vw" }}>
            {lakhField()}
            {thousandField()}
          </div>
        </>
      );
    return null;
  };

  return (
    <>
      <button
        title="Update Highway Project"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave-document"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Update Highway Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="form-flex-wrap">
              {/* Row 1 — Code + Short Name */}
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                <div className="flex-column">
                  <label
                    htmlFor="pr_code"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Project Code<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="pr_code"
                    name="pr_code"
                    placeholder="Project code"
                    onChange={handleInputChange}
                    value={formData.pr_code}
                    style={{ width: "15vw" }}
                    className={`form-input-date ${errors.pr_code ? "input-error" : ""}`}
                  />
                  {errors.pr_code && (
                    <span className="error-message font-size-text">
                      {errors.pr_code}
                    </span>
                  )}
                </div>
                <div className="flex-column">
                  <label
                    htmlFor="project_short_name"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Project Short Name<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="project_short_name"
                    name="project_short_name"
                    placeholder="Project Short Name"
                    onChange={handleInputChange}
                    style={{ width: "15vw" }}
                    value={formData.project_short_name}
                    className={`form-input-date ${errors.project_short_name ? "input-error" : ""}`}
                  />
                  {errors.project_short_name && (
                    <span className="error-message font-size-text">
                      {errors.project_short_name}
                    </span>
                  )}
                </div>
              </div>

              {/* Row 2 — Company + SubCompany */}
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Company Name <span className="required">*</span>
                  </label>
                  {company.length === 0 ? (
                    <div className="form-loader" style={{ width: "15vw" }}>
                      <div
                        className="bar-loader"
                        style={{ width: "15vw" }}
                      ></div>
                    </div>
                  ) : (
                    <>
                      <Select
                        options={companyOptions}
                        onChange={handleCompanyInputOptions}
                        value={
                          companyOptions?.find(
                            (o) => o.value === formData.subcompany,
                          ) || null
                        }
                        placeholder="Select Company Name"
                        isSearchable
                        isClearable
                        styles={CSSForSelect15VW}
                      />
                      {errors.subcompany && (
                        <span className="error-message font-size-text">
                          {errors.subcompany}
                        </span>
                      )}
                    </>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    SubCompany <span className="required">*</span>
                  </label>
                  <Select
                    options={subCompanyOptions}
                    onChange={handleSubCompanyInputOptions}
                    value={
                      subCompanyOptions?.find(
                        (o) => o.value === formData.division,
                      ) || null
                    }
                    placeholder="Select Sub Company"
                    isSearchable
                    isClearable
                    noOptionsMessage={() =>
                      !formData.subcompany || formData.subcompany === "null"
                        ? "(Select Company First)"
                        : "No other options"
                    }
                    styles={CSSForSelect15VW}
                  />
                  {errors.division && (
                    <span className="error-message font-size-text">
                      {errors.division}
                    </span>
                  )}
                </div>
              </div>

              {/* Project Name */}
              <div style={{ width: "98.5%" }} className="flex-column">
                <label
                  htmlFor="project_name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Project Name<span className="required">*</span>
                </label>
                <textarea
                  id="project_name"
                  name="project_name"
                  placeholder="Project Name"
                  onChange={handleInputChange}
                  value={formData.project_name}
                  style={{ width: "100%" }}
                  className={`form-input form-input-textarea ${errors.project_name ? "input-error" : ""}`}
                />
                {errors.project_name && (
                  <span className="error-message font-size-text">
                    {errors.project_name}
                  </span>
                )}
              </div>

              {/* Row 3 — Sector (read-only) + Department */}
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Sector <span className="required">(Read-Only)</span>
                  </label>
                  <Select
                    options={extendedSectorOption}
                    value={
                      extendedSectorOption.find(
                        (o) => o.value === formData.sector,
                      ) || null
                    }
                    isDisabled
                    placeholder="Highway"
                    styles={CSSForSelect15VW}
                  />
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Department <span className="required">*</span>
                  </label>
                  <Select
                    options={departmentHighwayOption}
                    onChange={handleDepartmentChange}
                    value={
                      departmentHighwayOption.find(
                        (o) => o.value === formData.department,
                      ) || null
                    }
                    placeholder="Select Department"
                    isSearchable
                    isClearable
                    styles={CSSForSelect15VW}
                  />
                  {errors.department && (
                    <span className="error-message font-size-text">
                      {errors.department}
                    </span>
                  )}
                </div>
              </div>

              {/* Row 4 — Work Type + Total Length */}
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                {formData.work_type_id !== "other" ? (
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Work Type <span className="required">*</span>
                    </label>
                    <Select
                      options={extendedworkTypeOption}
                      onChange={handleWorkTypeOption}
                      value={
                        extendedworkTypeOption.find(
                          (o) => o.value === formData.work_type_id,
                        ) || null
                      }
                      placeholder="Select WorkType"
                      isSearchable
                      isClearable
                      styles={CSSForSelect15VW}
                    />
                    {errors.work_type_id && (
                      <span className="error-message font-size-text">
                        {errors.work_type_id}
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="flex-column">
                    <div className="flex-row justify-between">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Work Type Name<span className="required">*</span>
                      </label>
                      <div className="flex-row">
                        <button
                          onClick={() => setRemoveWorkTypeInputField(true)}
                          style={{
                            height: "20px",
                            width: "20px",
                            borderRadius: "50%",
                            border: "2px solid red",
                            color: "red",
                            background: "white",
                            fontWeight: "400",
                            fontSize: "20px",
                            marginRight: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button>
                        <AddWithPlus
                          onClick={handleFormSubmit2}
                          title="Submit"
                        />
                      </div>
                    </div>
                    <input
                      type="text"
                      maxLength={100}
                      name="name"
                      placeholder="Work Type Name"
                      onChange={(e) => {
                        setFormData2((p) => ({ ...p, name: e.target.value }));
                        setErrors2((p) => {
                          const u = { ...p };
                          delete u.name;
                          return u;
                        });
                      }}
                      style={{ width: "20vw" }}
                      value={formData2.name}
                      className={`form-input ${error2.name ? "input-error" : ""}`}
                    />
                    {error2.name && (
                      <span className="error-message font-size-text">
                        {error2.name}
                      </span>
                    )}
                  </div>
                )}
                <div className="flex-column">
                  <label
                    htmlFor="total_length"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Total Length(in KM)<span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    id="total_length"
                    name="total_length"
                    placeholder="Total Length"
                    style={{ width: "15vw" }}
                    onChange={handleInputChange}
                    value={formData.total_length}
                    className={`form-input ${errors.total_length ? "input-error" : ""}`}
                  />
                  {errors.total_length && (
                    <span className="error-message font-size-text">
                      {errors.total_length}
                    </span>
                  )}
                </div>
              </div>

              {/* Cost Section */}
              {renderCostSection()}

              {/* GST + Total Amount */}
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                <div className="flex-column">
                  <label
                    htmlFor="gst_amount"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    GST Amount (₹)
                  </label>
                  <input
                    type="number"
                    id="gst_amount"
                    name="gst_amount"
                    placeholder="GST Amount"
                    style={{ width: "15vw" }}
                    onChange={handleGstChange}
                    value={formData.gst_amount ?? ""}
                    className="form-input"
                  />
                </div>
                <div className="flex-column">
                  <label
                    htmlFor="total_amount"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Total Amount (₹)<span className="required">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    id="total_amount"
                    style={{ width: "15vw" }}
                    value={
                      Number(formData.project_post || 0) +
                      Number(formData.gst_amount || 0)
                    }
                    readOnly
                    className="form-input"
                  />
                </div>
              </div>

              {/* Row 5 — LOA Date + Completion Date */}
              <div
                className="flex-row justify-between"
                style={{ width: "35vw" }}
              >
                <div className="flex-column">
                  <label
                    htmlFor="loa_date"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    LOA Date<span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="loa_date"
                    name="loa_date"
                    style={{ width: "15vw" }}
                    onChange={handleInputChange}
                    value={formData.loa_date}
                    className={`form-input ${errors.loa_date ? "input-error" : ""}`}
                  />
                  {errors.loa_date && (
                    <span className="error-message font-size-text">
                      {errors.loa_date}
                    </span>
                  )}
                </div>
                <div className="flex-column">
                  <label
                    htmlFor="completion_date"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    Completion Date<span className="required">*</span>
                  </label>
                  <input
                    type="date"
                    id="completion_date"
                    name="completion_date"
                    style={{ width: "15vw" }}
                    onChange={handleInputChange}
                    value={formData.completion_date}
                    min={formData.loa_date}
                    className={`form-input ${errors.completion_date ? "input-error" : ""}`}
                  />
                  {errors.completion_date && (
                    <span className="error-message font-size-text">
                      {errors.completion_date}
                    </span>
                  )}
                </div>
              </div>

              {/* Workstages */}
              <div className="flex-column form-group-selectt">
                <label className="form-labels font-weight500 font-size-subheading">
                  WorkStat List<span className="required">*</span>
                </label>
                <br />
                <Select
                  options={extendedWorkStatOption}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option, MenuList }}
                  placeholder="Select Name"
                  onChange={(selected) =>
                    setFormData((prev) => ({
                      ...prev,
                      workstages: selected
                        ? selected.map((item) => item.value)
                        : [],
                    }))
                  }
                  value={formData.workstages
                    ?.map((val) =>
                      extendedWorkStatOption.find((opt) => opt.value === val),
                    )
                    .filter(Boolean)}
                  styles={{
                    control: (p) => ({
                      ...p,
                      width: "33.5vw",
                      minHeight: "50px",
                      borderRadius: "10px",
                      border: "1px solid #e3e3e3",
                      margin: "10px 0px 20px 0px",
                      color: "#4a4a4a",
                      backgroundColor: "#f7f8fa",
                      padding: "0px 10px",
                    }),
                    menu: (p) => ({
                      ...p,
                      width: "33.5vw",
                      borderRadius: "10px",
                      marginTop: "0",
                    }),
                    option: (p, s) => ({
                      ...p,
                      backgroundColor:
                        s.isSelected || s.isFocused ? "#cfe2ff" : "white",
                      color: "#4a4a4a",
                      padding: "8px 12px",
                      ":active": { backgroundColor: "#cfe2ff" },
                    }),
                  }}
                />
                {errors.workstages && (
                  <span className="error-message font-size-text">
                    {errors.workstages}
                  </span>
                )}
              </div>

              {/* Add new workstage inline */}
              {formData.workstages?.includes("other") && (
                <>
                  <div className="flex-column">
                    <div className="flex-row justify-between">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Work Stage Name<span className="required">*</span>
                      </label>
                      <AddWithPlus
                        onClick={handleFormSubmit4}
                        title="Add Work Stage"
                      />
                    </div>
                    <input
                      type="text"
                      maxLength={100}
                      name="name"
                      placeholder="Work Stage Name"
                      onChange={(e) =>
                        setFormData4((p) => ({ ...p, name: e.target.value }))
                      }
                      value={formData4.name}
                      className={`form-input ${error4.name ? "input-error" : ""}`}
                    />
                    {error4.name && (
                      <span className="error-message font-size-text">
                        {error4.name}
                      </span>
                    )}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      WorkStat Input Type<span className="required">*</span>
                    </label>
                    <Select
                      options={inputOptions}
                      onChange={(sel) => setinputValue(sel ? sel.value : "")}
                      value={
                        inputOptions.find(
                          (o) => o.value === formData4.workstage_inputtype,
                        ) || null
                      }
                      placeholder="Select Input Type"
                      isSearchable
                      isClearable
                      styles={CSSForSelect}
                    />
                    {error4.workstage_inputtype && (
                      <span className="error-message font-size-text">
                        {error4.workstage_inputtype}
                      </span>
                    )}
                  </div>
                </>
              )}
            </div>

            <div className="button-models" style={{ width: "100%" }}>
              <button
                type="submit"
                className="model-button font-weight500 model-button-submit"
                onClick={handleFormSubmit}
              >
                Update
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpdateHighwayProject;